import React, { useEffect, useState, useRef } from 'react';
import './DataFeed.css';
import { useDispatch, useSelector } from 'react-redux';
import { getDataFeed } from '../../../actions/DataFeedAction';
import DatumList from './Datum/DatumList';
import { fetchThemesAutocomplete } from '../../../api/ThemeManipulation';
import { AiOutlineBarChart } from 'react-icons/ai';
import { LiaTimesSolid } from 'react-icons/lia';
import { BiFilterAlt, BiTrash } from 'react-icons/bi';
import DraftModal from '../../../components/Main/Feed/Datum/DraftModal';
import { datumReload } from '../../../actions/datumeditAction';
import { MdFilterAltOff } from 'react-icons/md';
import { searchUsers } from '../../../api/UserRequest';
import { searchItems } from '../../../api/ItemRequest';
import { searchSubscribedAuthors } from '../../../api/UserFeedRequest';
import { fetchThemeById } from '../../../api/ThemeManipulation';
import InfiniteScrollLoader from '../ItemFeed/InfiniteScrollLoader';
import { saveFilters, loadFilters, clearSavedFilters } from '../../../utils/filterPersistence';
import { TbFaceIdError } from 'react-icons/tb';

const DataFeed = ({ setMainContent, sortOrder, user: propUser }) => {
  const dispatch = useDispatch();
  const { user: reduxUser } = useSelector((state) => state.authReducer.authData);
  const { loading: authDataLoading } = useSelector((state) => state.authReducer);
  const { dataFeed, loading: dataFeedLoading, hasMore, totalItems } = useSelector((state) => state.dataFeedReducer);
  const [page, setPage] = useState(0);
  const [displayThemes, setDisplayThemes] = useState(null);
  const isReload = useSelector((state) => state.datumeditReducer.isReload);
  const { modalData } = useSelector((state) => state.modalReducer);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isOpen = useSelector((state) => state.datumeditReducer.isOpen);
  const user = propUser || reduxUser;
  const [disabled, setDisabled] = useState(false)

  // User search
  const [userSearchResults, setUserSearchResults] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userSearchInput, setUserSearchInput] = useState('');

  // Item search
  const [itemSearchResults, setItemSearchResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemSearchInput, setItemSearchInput] = useState('');

  // Datum search
  const [datumIdInput, setDatumIdInput] = useState('')

  // Author search
  const [authorSearchResults, setAuthorSearchResults] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [authorSearchInput, setAuthorSearchInput] = useState('');

  useEffect(() => {
    if (isOpen === true) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [isOpen]);

  const FILTER_KEY = 'dataFeed_filters'

  const filtersObj = {
    datumId: null,
    group: null,
    authorName: null,
    username: null,
    keyword: null,
    subscribed: false,
    followed: false,
    theme: null,
    reference: null,
    includeStamped: false,
    includeViewed: false,
    includeUnsubscribedAuthors: false,
    subscribedAuthorsOnly: true,
    sortBy: sortOrder || 'default',
  };
  
  const [filters, setFilters] = useState(() => loadFilters(FILTER_KEY, filtersObj, user._id));

  useEffect(() => {
    saveFilters(FILTER_KEY, filters, user._id);
  }, [filters]);

  useEffect(() => {
    const restoreFilters = async () => {
        const saved = loadFilters(FILTER_KEY, filtersObj, user._id);

        if (saved.username) {
            const res = await searchUsers(saved.username, user.userType === 0 ? null : 1);
            const match = res.data.find(u => u.username === saved.username);
            if (match) setSelectedUser(match);
        }

        if (saved.authorName) {
            const res = await searchSubscribedAuthors(user._id, saved.authorName);
            const match = res.data.find(u => u.username === saved.authorName);
            if (match) setSelectedAuthor(match);
        }

        if (saved.reference) {
            const res = await searchItems(saved.reference);
            const match = res.data.find(u => u._id === saved.reference);
            if (match) setSelectedItem(match);
        }

        if (saved.theme) {
            const res = await fetchThemeById(saved.theme);
            if (res.data) {
                const theme = res.data;
                setDisplayThemes(
                    <span className='FlexRow'>
                        <div className='df-selected-theme'>
                            <div className='atm-result-theme'>{theme.theme}</div>
                            <div className='atm-result-stats'>
                                <AiOutlineBarChart />
                                {theme.dataCount}
                            </div>
                        </div>
                        <LiaTimesSolid onClick={removeTheme} />
                    </span>
                );
            }
        }

        if (saved.datumId) {
            setDatumIdInput(saved.datumId);
            setDisabled(true);
        }
    };

    restoreFilters();
}, []);

  // Fetch data based on sortOrder (either 'stamped' or 'recent')
  useEffect(() => {
    dispatch(getDataFeed(user._id, JSON.stringify({ ...filters, sortOrder }), 0));
  }, [sortOrder]);

  useEffect(() => {
    if (isReload === true) {
      const savedFilters = loadFilters(FILTER_KEY, filtersObj, user._id)
      dispatch(getDataFeed(user._id, JSON.stringify(savedFilters), 0));
      dispatch(datumReload(false));
    }
  }, [isReload]);

  useEffect(() => {
    if (!authDataLoading) {
      const savedFilters = loadFilters(FILTER_KEY, filtersObj, user._id)
      dispatch(getDataFeed(user._id, JSON.stringify(savedFilters), 0));
    }
  }, [authDataLoading]);

  const hasMoreRef = useRef(hasMore);
  const isFetchingRef = useRef(false);
  const loadingRef = useRef(dataFeedLoading);
  const pageRef = useRef(page);
  const filtersRef = useRef(filters)

  useEffect(() => { hasMoreRef.current = hasMore; }, [hasMore]);
  useEffect(() => { loadingRef.current = dataFeedLoading; }, [dataFeedLoading]);
  useEffect(() => { pageRef.current = page; }, [page]);
  useEffect(() => {filtersRef.current = filters; }, [filters]);

  useEffect(() => {
    const appContainer = document.querySelector('.App');
          
    const handleScroll = () => {
        const nearBottom =
            appContainer.scrollHeight - appContainer.scrollTop - appContainer.clientHeight < 200;
                          
        if (nearBottom && hasMoreRef.current && !isFetchingRef.current) {
            isFetchingRef.current = true;
            const nextPage = pageRef.current + 1;
            setPage(nextPage);
            dispatch(getDataFeed(user._id, JSON.stringify(filtersRef.current), nextPage)).finally(() => {
              isFetchingRef.current = false;
            });
        }
    };
      
    appContainer.addEventListener('scroll', handleScroll);
    return () => appContainer.removeEventListener('scroll', handleScroll);
  }, []);

  const themeAutocomplete = async () => {
    const inputEl = document.getElementById('themeSearch');
    const value = inputEl.value;
    if (value.length > 2) {
      const res = await fetchThemesAutocomplete(value);
      const data = res.data;
      setDisplayThemes(
        data?.map((theme) => (
          <div className='atm-result' onClick={() => selectTheme(theme)}>
            <div className='atm-result-theme'>{theme.theme}</div>
            <div className='atm-result-stats'>
              <AiOutlineBarChart />
              {theme.dataCount}
            </div>
          </div>
        ))
      );
    } else {
      setDisplayThemes(null);
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const selectTheme = (theme) => {
    setDisplayThemes(
      <span className='FlexRow'>
        <div className='df-selected-theme'>
          <div className='atm-result-theme'>{theme.theme}</div>
          <div className='atm-result-stats'>
            <AiOutlineBarChart />
            {theme.dataCount}
          </div>
        </div>
        <LiaTimesSolid onClick={removeTheme} />
      </span>
    );
    document.getElementById('themeSearch').value = '';
    setFilters({ ...filters, theme: theme._id });
  };

  const removeTheme = () => {
    setDisplayThemes(null);
    setFilters({ ...filters, theme: null });
  };

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: checked,
    }));
  };

  const handleSubmitFilters = (e) => {
    e.preventDefault();
    setPage(0)
    dispatch(getDataFeed(user._id, JSON.stringify(filters), 0));
  };

  const handleDatumIdSearch = (e) => {
    const value = e.target.value;
    setDatumIdInput(value);
    if (value) {
        setFilters({ ...filtersObj, datumId: value });
        setDisabled(true)
        setDisplayThemes(null);
        setSelectedUser(null);
        setUserSearchInput('')
        setUserSearchResults([]);
        setSelectedItem(null);
        setItemSearchInput('')
        setItemSearchResults([]);
        setSelectedAuthor(null);
        setAuthorSearchInput('')
        setAuthorSearchResults([]);
        
        document.getElementById('themeSearch').value = '';
        document.querySelectorAll('#dataFeed_filter_bar input[type="text"]').forEach(input => {
            if (input.name !== 'datumId') input.value = '';
        });
        document.querySelectorAll('#dataFeed_filter_bar input[type="checkbox"]').forEach(input => {
            input.checked = false;
        });
    } else {
        setDisabled(false);
        setFilters({ ...filtersObj, datumId: null });
    }
};

  const clearFilters = () => {
    clearSavedFilters(FILTER_KEY, user._id);
    setFilters(filtersObj);

    setDisplayThemes(null);
    setSelectedUser(null);
    setUserSearchInput('');
    setDatumIdInput('');
    setUserSearchResults([]);
    setSelectedItem(null);
    setItemSearchInput('')
    setItemSearchResults([]);
    setSelectedAuthor(null);
    setAuthorSearchInput('')
    setAuthorSearchResults([]);
    setDisabled(false)

    setPage(0)
    document.getElementById('themeSearch').value = '';
    document.querySelectorAll('#dataFeed_filter_bar input[type="text"]').forEach(input => {
        input.value = '';
    });
    dispatch(getDataFeed(user._id, JSON.stringify(filtersObj), 0));
  };

  const handleUsernameSearch = async (e) => {
    const value = e.target.value;
    setUserSearchInput(value);
    if (value.length > 2) {
        const res = await searchUsers(value, user.userType === 0 ? null : 1);
        setUserSearchResults(res.data);
    } else {
        setUserSearchResults([]);
    }
  };

  const selectUser = (selectedUser) => {
      setSelectedUser(selectedUser);
      setUserSearchResults([]);
      setUserSearchInput('');
      if (user.userType === 0) {
        if (selectedUser.userType === 2) {
          setFilters({ ...filters, group: selectedUser._id });
        } else {
          setFilters({ ...filters, username: selectedUser.username });
        }
      } else {
          setFilters({ ...filters, username: selectedUser.username });
      }
  };

  const removeSelectedUser = () => {
      setSelectedUser(null);
      setUserSearchInput('');
      setFilters({ ...filters, username: null, group: null });
  };

  const handleItemSearch = async (e) => {
    const value = e.target.value;
    setItemSearchInput(value);
    if (value.length > 2) {
        const res = await searchItems(value);
        setItemSearchResults(res.data);
    } else {
        setItemSearchResults([]);
    }
  };

  const selectItem = (item) => {
      setSelectedItem(item);
      setItemSearchResults([]);
      setItemSearchInput('');
      setFilters({ ...filters, reference: item._id });
  };

  const removeSelectedItem = () => {
      setSelectedItem(null);
      setItemSearchInput('');
      setFilters({ ...filters, reference: null });
  };

  const handleAuthorSearch = async (e) => {
    const value = e.target.value;
    setAuthorSearchInput(value);
    if (value.length > 2) {
        const res = await searchSubscribedAuthors(user._id, value);
        setAuthorSearchResults(res.data);
    } else {
        setAuthorSearchResults([]);
    }
  };

  const selectAuthor = (author) => {
      setSelectedAuthor(author);
      setAuthorSearchResults([]);
      setAuthorSearchInput('');
      setFilters({ ...filters, authorName: author.username });
  };

  const removeSelectedAuthor = () => {
      setSelectedAuthor(null);
      setAuthorSearchInput('');
      setFilters({ ...filters, authorName: null });
  };

  function NoData() {
    var noItemsText = "";
    switch(user.userType) {
        case 0:
            if (user.follow.length === 0) {
              noItemsText = "You aren't following any Groups yet!  Click on Find Groups above, follow one or more whose Values align with yours, and you'll begin to see the Data that they think are most important for you to see.";    
            } else {
              noItemsText = (
                <>
                  Check your Filter and Sort options in the <span><BiFilterAlt /></span> menu above and try removing some filters.
                </>
              );
            } 
            break;
        case 1:
            noItemsText = "Categories are a useful way for Authors to organize their Items in a way that makes it easier for users to search and find them.  Be sure you're using Categories that your Group(s) use(s) for best results.";
            break;
        case 2:
            noItemsText = "Once you begin stamping Data with Category relations, the Items that they reference will appear here."
            break;
    }
    return (
        <div className='General-nr-container'>
            <span className='General-nr-top'>You don't have any Data in your Feed.</span>
            <TbFaceIdError size='30'/>
            <div className='General-nr-hint'>{noItemsText}</div>
        
        </div>
    )
  }

  return (
    <>
      <div className='General-filter-bar General-hidden' id='dataFeed_filter_bar'>
        <form action='' className='FlexColumn General-filter-form' onSubmit={handleSubmitFilters}>
            <span className='FlexRow General-filter-form'>
            <span className='General-filter-key'>Datum ID:</span>
            <div style={{ position: 'relative', width: '77%' }}>
                <input
                    type="text"
                    placeholder="Search by Datum ID..."
                    name="datumId"
                    className='General-input'
                    value={datumIdInput}
                    onChange={handleDatumIdSearch}
                    style={{ paddingRight: '24px', width: '100%' }}
                />
                {datumIdInput && (
                    <BiTrash
                        onClick={() => {
                            setDatumIdInput('');
                            setDisabled(false);
                            setFilters({ ...filtersObj, datumId: null });
                        }}
                        style={{
                            position: 'absolute',
                            marginLeft: 'auto',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#6b7280'
                        }}
                    />
                )}
            </div>
        </span>
          {/* Username field — userType 0 and 2 only, not for authors (1) */}
          {user.userType !== 1 && (
              <span className='FlexRow General-filter-form'>
                  <span className='General-filter-key'>
                      Username
                  </span>
                  <div style={{ position: 'relative', width: '77%' }}>
                      {selectedUser ? (
                          <div className='user-search-selected FlexRow'>
                              <img
                                  src={process.env.REACT_APP_PUBLIC_FOLDER + selectedUser.userImage}
                                  className='user-search-img'
                              />
                              <span>{selectedUser.displayname}</span>
                              <span className='user-search-at'>@{selectedUser.username}</span>
                              <BiTrash
                                  className='user-search-remove'
                                  onClick={removeSelectedUser}
                              />
                          </div>
                      ) : (
                          <input
                              type="text"
                              placeholder={"Search by user name..."}
                              className='General-input'
                              value={userSearchInput}
                              onChange={handleUsernameSearch}
                              disabled={disabled}
                              style={{ paddingRight: '24px', width: '100%' }}
                          />
                      )}
                      {userSearchResults.length > 0 && (
                        <div className='user-search-dropdown'>
                            {userSearchResults.map((u) => (
                              <div 
                                key={u._id} 
                                className='user-search-result FlexRow'
                                onClick={() => selectUser(u)}
                              >
                              <img 
                                src={process.env.REACT_APP_PUBLIC_FOLDER + u.userImage} 
                                className='user-search-img'
                              />
                              <div className='FlexColumn'>
                                <span>{u.displayname}</span>
                                <span className='user-search-at'>@{u.username}</span>
                              </div>
                          </div>
                        ))}
                      </div>
                      )}
                  </div>
              </span>
          )}
          <span className='FlexRow General-filter-form'>
            <span className='General-filter-key'>Keyword:</span>
            <div style={{ position: 'relative', width: '77%' }}>
              <input
                type="text"
                placeholder="Filter by keyword..."
                name="keyword"
                className='General-input'
                value={filters.keyword || ''}
                onChange={handleChange}
                disabled={disabled}
                style={{ paddingRight: '24px', width: '100%' }}
              />
              {filters.keyword && (
                <BiTrash
                  onClick={() => setFilters({ ...filters, keyword: null })}
                    style={{ 
                    position: 'absolute', 
                    marginLeft: 'auto', 
                    top: '50%', 
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#6b7280'
                  }}
                />
              )}
            </div>
          </span>
          <span className='FlexRow General-filter-form'>
            <span className='General-filter-key'>Item:</span>
            <div style={{ position: 'relative', width: '77%' }}>
                {selectedItem ? (
                    <div className='user-search-selected FlexRow' style={{ alignItems: 'flex-start' }}>
                    <img
                        src={process.env.REACT_APP_PUBLIC_FOLDER + selectedItem.image}
                        className='user-search-img'
                        style={{ borderRadius: '4px', flexShrink: 0 }}
                    />
                    <div className='FlexColumn' style={{ alignItems: 'flex-start', flex: 1 }}>
                        <span style={{ textAlign: 'left' }}>{selectedItem.itemName}</span>
                        {selectedItem.author && (
                            <span className='FlexRow' style={{ gap: '4px', alignItems: 'center' }}>
                                <img
                                    src={process.env.REACT_APP_PUBLIC_FOLDER + selectedItem.author.userImage}
                                    style={{ width: '14px', height: '14px', borderRadius: '50%', flexShrink: 0 }}
                                />
                                <span className='user-search-at' style={{ fontSize: '0.72rem' }}>
                                    {selectedItem.author.displayname} @{selectedItem.author.username}
                                </span>
                            </span>
                        )}
                    </div>
                    <BiTrash
                        className='user-search-remove'
                        style={{ flexShrink: 0 }}
                        onClick={removeSelectedItem}
                    />
                  </div>
                ) : (
                    <input
                        type="text"
                        placeholder="Filter by referenced item..."
                        className='General-input'
                        value={itemSearchInput}
                        onChange={handleItemSearch}
                        disabled={disabled}
                        style={{ paddingRight: '24px', width: '100%' }}
                    />
                )}
                {itemSearchResults.length > 0 && (
                  <div className='user-search-dropdown'>
                      {itemSearchResults.map((item) => (
                        <div
                          key={item._id}
                          className='user-search-result FlexRow'
                          onClick={() => selectItem(item)}
                          style={{ alignItems: 'flex-start' }}
                        >
                          <img
                              src={process.env.REACT_APP_PUBLIC_FOLDER + item.image}
                              className='user-search-img'
                              style={{ borderRadius: '4px', flexShrink: 0 }}
                          />
                          <div className='FlexColumn' style={{ alignItems: 'flex-start', flex: 1 }}>
                              <span style={{ textAlign: 'left' }}>{item.itemName}</span>
                              {item.author && (
                                  <span className='FlexRow' style={{ gap: '4px', alignItems: 'center' }}>
                                      <img
                                          src={process.env.REACT_APP_PUBLIC_FOLDER + item.author.userImage}
                                          style={{ width: '14px', height: '14px', borderRadius: '50%', flexShrink: 0 }}
                                      />
                                      <span className='user-search-at' style={{ fontSize: '0.72rem' }}>
                                          {item.author.displayname} @{item.author.username}
                                      </span>
                                  </span>
                              )}
                          </div>
                      </div>
                      ))}
                  </div>
              )}
            </div>
        </span>
          <div className='FlexColumn General-filter-form'>
            <span className='FlexRow General-filter-form'>
              <span className='General-filter-key'>Theme:</span>
              <input
                id='themeSearch'
                onChange={themeAutocomplete}
                name='themeSearch'
                type='text'
                disabled={disabled}
                placeholder='Filter by theme...'
              />
            </span>
            <div className='df-themes-container'>{displayThemes}</div>
            {user.userType === 2 && (
              <span className='FlexRow General-filter-form'>
                  <span className='General-filter-key'>Author:</span>
                  <div style={{ position: 'relative', width: '77%' }}>
                      {selectedAuthor ? (
                          <div className='user-search-selected FlexRow'>
                              <img
                                  src={process.env.REACT_APP_PUBLIC_FOLDER + selectedAuthor.userImage}
                                  className='user-search-img'
                              />
                              <span>{selectedAuthor.displayname}</span>
                              <span className='user-search-at'>@{selectedAuthor.username}</span>
                              <BiTrash
                                  className='user-search-remove'
                                  onClick={removeSelectedAuthor}
                              />
                          </div>
                      ) : (
                          <input
                              type="text"
                              placeholder="Search subscribed authors..."
                              className='General-input'
                              value={authorSearchInput}
                              disabled={disabled}
                              onChange={handleAuthorSearch}
                              style={{ paddingRight: '24px', width: '100%' }}
                          />
                      )}
                      {authorSearchResults.length > 0 && (
                          <div className='user-search-dropdown'>
                              {authorSearchResults.map((u) => (
                                <div 
                                  key={u._id} 
                                  className='user-search-result FlexRow'
                                  onClick={() => selectAuthor(u)}
                                >
                                <img 
                                  src={process.env.REACT_APP_PUBLIC_FOLDER + u.userImage} 
                                  className='user-search-img'
                                />
                                <div className='FlexColumn'>
                                  <span>{u.displayname}</span>
                                  <span className='user-search-at'>@{u.username}</span>
                                </div>
                              </div>
                              ))}
                          </div>
                      )}
                  </div>
              </span>
            )}
            {user.userType === 2 ?
            <>
              <span className="FlexRow General-filter-form">
              <label className="small-label">
                <input
                  type="checkbox"
                  name="includeStamped"
                  checked={filters.includeStamped}
                  disabled={disabled}
                  onChange={handleCheckboxChange}
                />
                Include Stamped Data
              </label>
            </span>
            <span className="FlexRow General-filter-form">
              <label className="small-label">
                <input
                  type="checkbox"
                  name="includeViewed"
                  checked={filters.includeViewed}
                  disabled={disabled}
                  onChange={handleCheckboxChange}
                />
                Include Viewed Data
              </label>
            </span>
            <span className="FlexRow General-filter-form">
              <label className="small-label">
                <input
                  type="checkbox"
                  name="includeUnsubscribedAuthors"
                  checked={filters.includeUnsubscribedAuthors}
                  disabled={disabled}
                  onChange={handleCheckboxChange}
                />
                Include Unsubscribed Authors
              </label>
            </span>
            </>
          : "" }  
          </div>
          <span className='FlexRow General-filter-form'>
          <span className='General-filter-key'>Sort By:</span>
          <select
              name='sortBy'
              className=''
              onChange={handleChange}
              disabled={disabled}
              value={filters.sortBy || 'default'}
          >
              {user.userType === 0 && <>
                  <option value='recentlyStamped'>Most Recently Stamped (Default)</option>
                  <option value='oldestStamped'>Oldest Stamped First</option>
                  <option value='mostStamped'>Most Stamped</option>
              </>}
              {user.userType === 1 && <>
                  <option value='recentlyCreated'>Most Recently Created (Default)</option>
                  <option value='oldestCreated'>Oldest Created First</option>
                  <option value='mostStamped'>Most Stamped</option>
              </>}
              {user.userType === 2 && <>
                  <option value='recentlyCreated'>Most Recently Created (Default)</option>
                  <option value='oldestCreated'>Oldest Created First</option>
                  <option value='recentlyStamped'>Most Recently Stamped</option>
                  <option value='oldestStamped'>Oldest Stamped First</option>
              </>}
          </select>
        </span>
          <div className='FlexRow General-filter-form items-center flex justify-center'>
            <button className='button signupButton' type='submit'>
                Apply Filters
            </button>
            <button 
                className='button signupButton' 
                type='button' 
                onClick={clearFilters}
                title='Clear all filters'
            >
                <MdFilterAltOff />
            </button>
        </div>
        </form>
      </div>
      <div className='feed-result-count'>
      {dataFeedLoading ?
          "Loading" :
          `Search returned ${totalItems} ${totalItems === 1 ? 'Datum' : 'Data'}`}
      </div>
      <div className='DataFeed'>
        {dataFeed && dataFeed.length > 0 ? (
          dataFeed.map((datum) => (
            <DatumList data={datum} id={datum._id} key={datum._id} setMainContent={setMainContent} datum_state='pubdatum' />
          ))
        ) : (
          <div className='UserFeed'>
            {dataFeedLoading
              ? 'Loading...'
              : <NoData/>}
          </div>
        )}
      </div>
      {dataFeed && dataFeed.length > 0 && (
          <InfiniteScrollLoader hasMore={hasMore} />
      )}

      {isOpen && modalData && (
        <DraftModal
          setMainContent={setMainContent}
          onClose={toggleModal}
          openFlag={isOpen}
          datum_i={modalData.data}
          ceFlag='2'
          btn_flag='public'
          datum_state='pubdatum'
        />
      )}
    </>
  );
};

export default DataFeed;
